import DoAPICall from './DoAPICall'

//Create Billpay Settings
    export async function createBillpaySettings(userToken, billpaySettings){
        const apiPayload = {
            httpMethod:'post',
            userToken,
            uri:'billpaysettings',
            payLoad:{
                description:billpaySettings.description,
                keyValue:billpaySettings.keyValue,
                key:billpaySettings.key,
            },
            requestOptions:{}
        }
        return await DoAPICall(apiPayload)
    }

//Get All Billpay Settings
    export async function getBillpaySettings(userToken){
        const apiPayload = {
            httpMethod:'get',
            userToken,
            uri:'billpaysettings',
            payLoad:{},
            requestOptions:{}
        }
        return await DoAPICall(apiPayload)
    }

//Get One Billpay Settings
    export async function getBillpaySetting(userToken, id){
        const apiPayload = {
            httpMethod:'get',
            userToken,
            uri:'billpaysettings/'+id,
            payLoad:{},
            requestOptions:{}
        }
        return await DoAPICall(apiPayload)
    }

//Update Billpay Settings
    export async function updateBillpaySettings(userToken, billpaySettings){
        const apiPayload = {
            httpMethod:'put',
            userToken,
            uri:'billpaysettings/'+billpaySettings.id,
            payLoad:{
                description:billpaySettings.description,
                keyValue:billpaySettings.keyValue,
                key:billpaySettings.key
            },
            requestOptions:{}
        }
        return await DoAPICall(apiPayload)
    }

//Delete Billpay Settings
    export async function deleteBillpaySettings(userToken, id){
        const apiPayload = {
            httpMethod:'delete',
            userToken,
            uri:'billpaysettings/'+id,
            payLoad:{},
            requestOptions:{}
        }
        return await DoAPICall(apiPayload)
    }
